import {Col, Form, Input, Row, Select, Switch, TimePicker} from "antd";
import React, {useEffect, useState} from "react";
import { Option } from "antd/es/mentions";
import { useTranslation } from "react-i18next";
import {DG_TimeSelect} from "@dogoo/do-ant-design";

const { TextArea } = Input;

const MidShiftSetting = (props) => {
  const { t } = useTranslation();
  const [obligatoryMidShift, setObligatoryMidShift] = useState(false);
  const format = "HH:mm";
  const [arraySwitch, setArraySwitch] = useState({});

    useEffect(() => {
      setArraySwitch({
          ...props.dataShift
      })
  },[props.dataShift])

    useEffect(()=> {
        setObligatoryMidShift(arraySwitch.obligatoryMidShift)
        onPropsValueSwitch(arraySwitch)
    },[arraySwitch])

    const onPropsValueSwitch = (value) => {
        props.sendValueSwitchMidShift(value);
    };

    const onChangeObligatoryMidShift = (value) => {
      setArraySwitch({
          ...arraySwitch,
          obligatoryMidShift : !arraySwitch.obligatoryMidShift
      })
      setObligatoryMidShift(value);
  };

  const onChangeIsLateSoonBreak = (value) => {
      setArraySwitch({
          ...arraySwitch,
          isLateSoonBreak : !arraySwitch.isLateSoonBreak
      })
  };

  return (
    <div id={props.id}>

      <Row gutter={12}>
        <Col xxl={{ span: 8 }} xl={{ span: 8 }} lg={{ span: 8 }}>
            <Form.Item name="obligatoryMidShift" className="df__center-align">
              <Switch
                  size="small"
                  onChange={onChangeObligatoryMidShift}
                  checked={arraySwitch.obligatoryMidShift}
                  className={'mr-1 mb-1'}
              />
              <span>{t("shiftTitle.midShift")}</span>
            </Form.Item>

        </Col>
      </Row>
      {/*<Row gutter={12}>*/}
      {/*    <Col xxl={{ span: 6 }} xl={{ span: 6 }} lg={{ span: 6 }}>*/}
      {/*      <Form.Item*/}
      {/*        label={t("shiftTitle.overTime")}*/}
      {/*        name="breakTimeAdded"*/}
      {/*        labelCol={{*/}
      {/*          span: 24,*/}
      {/*        }}*/}
      {/*        wrapperCol={{*/}
      {/*          span: 24,*/}
      {/*        }}*/}
      {/*        initialValue="notallow"*/}
      {/*      >*/}
      {/*        <Select*/}
      {/*          name="breakTimeAdded"*/}

      {/*        >*/}
      {/*            <Option value="notallow">{t("tnp.components.timekeeping.text16")}</Option>*/}
      {/*            <Option value="auto">{t("tnp.components.timekeeping.text17")}</Option>*/}
      {/*            <Option value="by_application">{t("tnp.components.timekeeping.text18")}</Option>*/}
      {/*        </Select>*/}
      {/*      </Form.Item>*/}
      {/*    </Col>*/}
      {/*</Row>*/}
      {/*<Row gutter={12}>*/}
      {/*  <Col xxl={{ span: 8 }} xl={{ span: 8 }} lg={{ span: 8 }}>*/}
      {/*      <Form.Item name="isLateSoonBreak" className="df__center-align">*/}
      {/*        <Switch*/}
      {/*          name="isLateSoonBreak"*/}
      {/*          size="small"*/}
      {/*          disabled={!obligatoryMidShift}*/}
      {/*          onChange={onChangeIsLateSoonBreak}*/}
      {/*          checked={arraySwitch.isLateSoonBreak}*/}
      {/*          className={'mr-1 mb-1'}*/}
      {/*        />*/}
      {/*        <span className="padding-lr-10">*/}
      {/*          {t("shiftTitle.workingCheck")}*/}
      {/*        </span>*/}
      {/*      </Form.Item>*/}
      {/*  </Col>*/}
      {/*</Row>*/}
      <Row gutter={12}>
        <Col xxl={{ span: 6 }} xl={{ span: 6 }} lg={{ span: 6 }}>
            <Form.Item
              labelCol={{
                span: 24,
              }}
              wrapperCol={{
                span: 24,
              }}
              label={t("shiftTitle.checkFirstShift")}
              name="checkFirstShift"
              tooltip={() => {
                  return t("tnp.components.timekeeping.text19")
              }}
            >
                <TimePicker
                    name="checkFirstShift"
                    disabled={!obligatoryMidShift}
                    format={format}
                    style={{width: '100%'}}
                    changeOnBlur={true}
                />
            </Form.Item>
        </Col>
        <Col xxl={{ span: 6 }} xl={{ span: 6 }} lg={{ span: 6 }}>
            <Form.Item
              labelCol={{
                span: 24,
              }}
              wrapperCol={{
                span: 24,
              }}
              label={t("shiftTitle.checkNextShift")}
              name="checkNextShift"
            >
                <TimePicker
                    name="checkNextShift"
                    disabled={!obligatoryMidShift}
                    format={format}
                    style={{width: '100%'}}
                    changeOnBlur={true}
                />
            </Form.Item>
        </Col>
        </Row>

          <Row gutter={12}>
            <Col xxl={{ span: 6 }} xl={{ span: 6 }} lg={{ span: 6 }}>
            <Form.Item
              labelCol={{
                span: 24,
              }}
              wrapperCol={{
                span: 24,
              }}
              label={t("shiftTitle.noteShift")}
              name="note"
            >
              <TextArea name="note" rows={4} />
            </Form.Item>
            </Col>
          </Row>

    </div>
  );
};

export default MidShiftSetting;
